import "./loader.css"; // Import the CSS file

const AppLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default AppLoader;
